export default __webpack_public_path__ + "static/media/heroku.433564f2.webp";